import React from 'react'
import { useQuery } from '@tanstack/react-query'
import { getConversation } from '../../utils/services/chatFunctions'
import ChatShort from './ChatShort'

const ChatSummary = ({ userInfo, setActiveConversation, conversationId }) => {
    // Get user info
    const {
        data: userConversations,
        isLoading: isLoadingUserConversations,
        isError: isErrorUserConversations,
    } = useQuery({
        queryKey: ['userConversations'],
        queryFn: () => getConversation(userInfo._id),
        enabled: !!userInfo?._id, // Conditional fetching
        staleTime: 5 * 60 * 1000,
        retry: 0,
        onError: (err) => {
            console.error('Error fetching user info:', err)
        },
    })

    if (isLoadingUserConversations) {
        return <p>Chargement des conversations...</p>
    }

    if (isErrorUserConversations) {
        return <p>Erreur lors du chargement des conversations</p>
    }

    const handleSetActiveConversation = (conversation) => {
        setActiveConversation(conversation)
    }

    return (
        <div>
            <h2>Conversations</h2>
            {userConversations.length > 0 ? (
                userConversations.map((conversation) => {
                    if (conversationId === conversation._id) {
                        handleSetActiveConversation(conversation)
                    }
                    return (
                        <ChatShort
                            conversation={conversation}
                            onClick={() =>
                                handleSetActiveConversation(conversation)
                            }
                        />
                    )
                })
            ) : (
                <p>Aucune conversation trouvée</p>
            )}
        </div>
    )
}

export default ChatSummary
